/* Customer data page, after the click demo's section "Data": stat tiles, search, file table. */
.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: 28px 40px 48px;
  overflow-y: auto;
  min-width: 0;
}

.muted {
  margin: 0;
  color: var(--muted);
}

.notice {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  background: var(--warning-soft);
  border-radius: var(--radius);
  padding: var(--space-2) var(--space-2) var(--space-2) 16px;
}

.notice span {
  flex: 1;
}

.close {
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  color: var(--text);
  font-size: 22px;
  cursor: pointer;
}

.progress {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  background: var(--accent-soft);
  border-radius: var(--radius);
  padding: var(--space-3) 16px;
}

.progress > span:first-child {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
}

.bar {
  flex: 0 0 160px;
  height: 8px;
  border-radius: 999px;
  background: var(--surface);
  overflow: hidden;
}

.bar span {
  display: block;
  height: 100%;
  background: var(--accent);
}

.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.stat {
  background: var(--surface);
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 3px 8px rgb(2 48 71 / 10%);
}

.statLabel {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--muted);
}

.statValue {
  font-weight: 900;
  font-size: 28px;
  margin-top: 6px;
}

.search {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 420px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--muted);
}

.search input {
  min-height: 44px;
  border: none;
  border-radius: var(--radius);
  background: var(--surface);
  box-shadow: 0 2px 6px rgb(2 48 71 / 8%);
  padding: 0 14px;
  font: inherit;
  font-size: 15px;
  letter-spacing: 0;
  text-transform: none;
  color: var(--text);
}

.tableWrap {
  background: var(--surface);
  border-radius: 12px;
  box-shadow: 0 3px 8px rgb(2 48 71 / 10%);
  overflow-x: auto;
}

.table {
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;
}

.table th,
.table td {
  text-align: left;
  padding: 10px 20px;
  border-bottom: 1px solid var(--border);
  vertical-align: middle;
}

.table th {
  padding-top: 14px;
  padding-bottom: 14px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--muted);
}

.table th:last-child,
.table td:last-child {
  width: 64px;
}

.hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

.fileCell {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.type {
  flex: none;
  background: var(--surface-2);
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 700;
}

.fileName {
  font-weight: 700;
  color: var(--link);
  text-decoration: none;
  overflow-wrap: anywhere;
}

.fileName:hover {
  text-decoration: underline;
}

.mutedCell {
  color: var(--muted);
  white-space: nowrap;
}

.person {
  display: flex;
  align-items: center;
  gap: 10px;
}

.iconButton {
  width: 44px;
  height: 44px;
  border: none;
  border-radius: var(--radius);
  background: transparent;
  color: var(--text);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.iconButton:hover {
  background: var(--danger-soft);
  color: var(--danger);
}

.empty {
  margin: 0;
  padding: 32px 20px;
  color: var(--muted);
  text-align: center;
}

.backdrop {
  position: fixed;
  inset: 0;
  background: rgb(2 48 71 / 55%);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 140px var(--space-4) var(--space-4);
  z-index: 20;
}

.dialog {
  background: var(--surface);
  border-radius: 14px;
  box-shadow: 0 12px 32px rgb(2 48 71 / 35%);
  padding: 24px 26px;
  width: 100%;
  max-width: 460px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.dialogTitle {
  margin: 0;
  font-size: 22px;
  overflow-wrap: anywhere;
}

.text {
  margin: 0;
  line-height: 1.5;
}

.dialogActions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.button {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  padding: 0 18px;
  border: none;
  border-radius: var(--radius);
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}

.secondary {
  composes: button;
  background: var(--surface-2);
  color: var(--text);
}

.confirm {
  composes: button;
  background: var(--eyebrow);
  color: #ffffff;
}

@media (max-width: 720px) {
  .main {
    padding: var(--space-4) 16px 32px;
  }

  .backdrop {
    padding-top: 48px;
  }
}
